import { Component, OnDestroy, OnInit } from '@angular/core';
import { sub } from 'date-fns';
import { computed, observable } from 'mobx-angular';
import { Team } from 'netsocial-lib/src/app/interfaces/team';
import { ApiRequestService } from 'netsocial-lib/src/app/services/api-request/api-request.service';
import { BaseComponent } from 'netsocial-posting/src/app/interfaces/base.component';
import { ErrorService } from 'netsocial-posting/src/app/services/error/error.service';
import { TeamService } from 'netsocial-posting/src/app/services/team/team.service';
import { UserService } from 'netsocial-posting/src/app/services/user/user.service';
import { from, Subscription } from 'rxjs';

@Component({
  selector: 'app-leaderboard',
  templateUrl: './leaderboard.page.html',
  styleUrls: ['./leaderboard.page.scss'],
})
export class LeaderboardPage extends BaseComponent implements OnInit, OnDestroy {
  public _endDate = new Date();
  public _startDate = sub(new Date(), {
    months: 6,
  });

  public startDate = this._startDate;
  public endDate = this._endDate;

  constructor(
    private readonly teamService: TeamService,
    private readonly apiRequest: ApiRequestService,
    private readonly errorService: ErrorService,
    readonly userService: UserService
  ) {
    super(userService);
  }

  public getTeamsSubscription?: Subscription;
  private getContextOwnerSubscription: Subscription;

  public teams?: Team[];
  @observable public selectedTeams: Team[] = [];
  public _selectedTeams: Team[] = [];
  @observable public _selectedTeam: Team;

  public teamMemberName: string;
  public _teamMemberName: string;

  public perPageOptions = [25, 50, 100, 250, 500];
  @observable public _perPageSelected = 25;
  public perPageSelected = 25;

  @computed
  public get selectedTeamsIds() {
    return this.selectedTeams.map((team) => team.id);
  }

  DATA_FROM = {
    STARTDATESELECT: 'start date select',
    ENDDATESELECT: 'end date select',
    SELECTEDTEAMSELECT: 'selected team select',
    SEARCH: 'search',
  };

  ngOnInit() {
    this.getContextOwnerSubscription = this.apiRequest.getContextOwner().subscribe(() => {
      this.getTeams();
    });
  }

  ngOnDestroy() {
    this.getContextOwnerSubscription.unsubscribe();
    this.getTeamsSubscription?.unsubscribe();
  }

  private getTeams() {
    this.getTeamsSubscription = from(
      this.errorService.resolve(this.teamService.getTeams())
    ).subscribe((teams) => {
      this.teams = teams;
      this.getTeamsSubscription = undefined;
    });
  }

  applyFilter(value: Team | Date | string, dataFrom: string) {
    if (dataFrom === this.DATA_FROM.SELECTEDTEAMSELECT) {
      this._selectedTeam = value as Team;
      this._selectedTeams = [];
      if (this._selectedTeam) {
        this._selectedTeams.push(this._selectedTeam);
      }
      this.selectedTeams = this._selectedTeams;
    }

    if (dataFrom === this.DATA_FROM.STARTDATESELECT)
      this._startDate = this.startDate = value as Date;
    if (dataFrom === this.DATA_FROM.ENDDATESELECT) this._endDate = this.endDate = value as Date;
    if (dataFrom === this.DATA_FROM.SEARCH)
      this._teamMemberName = this.teamMemberName = value as string;
  }
}
